import UserSettingsModel from '../models/UserSettingsModel';

export default class UserSettingsCollection extends Backbone.Collection {
  constructor(options) {
    super(options);
    this.model = UserSettingsModel;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;
    let settings = payload.postData ? payload.postData : payload.settings;
    let preferences;
    let settingsUrl;

    if (settings) {
      preferences = settings.preferences;
    }

    switch (actionType) {
      case ActionTypes.GET_SETTINGS:
        Utils.setMakeshiftTokenHeader();
        settingsUrl = 
          appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV + 
          appConstants.ApiPaths.API_VERSION_PATH + 
          appConstants.EndPoints.GET_SETTINGS;
        UserSettingsStore.fetch({
          url: settingsUrl,
          type: 'GET',
          success: UserSettingsStore.onSettingsLoaded,
          fail: UserSettingsStore.onSettingsError,
        });
        break;

      case ActionTypes.SETTINGS_CHANGED:
        const model = UserSettingsStore.get(settings.id);
        model.set(settings);
        break;

      case ActionTypes.UPDATE_SETTINGS:
        Utils.setMakeshiftTokenHeader();
        settingsUrl =
          appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
          appConstants.ApiPaths.API_VERSION_PATH +
          appConstants.EndPoints.UPDATE_SETTINGS;
        UserSettingsStore.fetch({
          url: settingsUrl,
          type: 'PUT',
          // Explicit contentType + a pre-stringified body -- passing a plain
          // object as `data` here skips Backbone.sync's own JSON.stringify
          // (it only kicks in when `data` is omitted) and falls back to
          // jQuery's form-urlencoded serialization, which drops any "_methods"
          // field entirely once its array is empty (nothing to encode). That
          // silently left the field unchanged server-side instead of clearing
          // it -- e.g. disabling every channel for a notification type never
          // persisted.
          contentType: 'application/json',
          data: JSON.stringify({
            user_setting: payload.postData,
          }),
          success: UserSettingsStore.updateSuccessCallback,
          error: UserSettingsStore.updateErrorCallback,
        });
        break;
      case ActionTypes.ACCEPT_TOS:
        Utils.setMakeshiftTokenHeader();
        settingsUrl =
          appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
          appConstants.ApiPaths.API_VERSION_PATH +
          appConstants.EndPoints.GET_SETTINGS;
        UserSettingsStore.fetch({
          url: settingsUrl,
          type: 'PUT',
          contentType: 'application/json',
          data: JSON.stringify({
            user_setting: payload.data,
          }),
          success: UserSettingsStore.acceptTOSCallback,
          error: UserSettingsStore.updateErrorCallback,
        });
        break;
    }
  }
}
